import React from 'react';
import PropTypes from 'prop-types';

import withMessages from 'component-utilities/intl';

import { PrimaryButton, SecondaryButton } from 'v-c/Buttons/Components';
import { FormText, FormButtons, InputField, FormLabel } from 'v-c/Forms';
import { LoginFormItem, LoginFormTitle } from 'v-c/Login';
import LoadingIndicator from 'v-c/LoadingIndicator';

import { stateLogic, viewLogic } from './ForgottenPasswordRequestDeconstructed';

function ForgottenPasswordRequestComponent(props) {
    const {
        isButtonDisabled,
        getMessage,
        userConfig,
        onSubmit,
        onCancel,
        isProcessing,
        requestAlreadySent,
    } = viewLogic(props);

    return (
        <div>
            <LoginFormTitle>
                {getMessage('components.login.forgot_password.title')}
            </LoginFormTitle>
            {isProcessing && (
                <div style={{ margin: '10px 0 10px 0' }}>
                    <LoadingIndicator
                        userOverlay
                        orientation="left"
                        text={getMessage('components.general.loading')}
                        isLoading
                    />
                </div>
            )}

            {(!isProcessing && !requestAlreadySent) && (
                <data>
                    <FormLabel>
                        {getMessage('components.login.forgot_password.description')}
                    </FormLabel>
                    <LoginFormItem name="forgot-password-field">
                        <InputField
                            focused
                            data-field="reset-password"
                            {...userConfig}
                        />
                    </LoginFormItem>
                    <FormText>
                        {getMessage('components.login.forgot_password.hint_text')}
                    </FormText>
                    <FormButtons>
                        <PrimaryButton
                            data-action="reset-password"
                            onClick={onSubmit}
                            disabled={isButtonDisabled}
                        >
                            {getMessage('components.login.forgot_password.button')}
                        </PrimaryButton>
                        <SecondaryButton
                            data-action="back-to-login"
                            onClick={onCancel}
                            extraClassName="additional-button"
                        >
                            {getMessage('components.login.forgot_password.cancel')}
                        </SecondaryButton>
                    </FormButtons>
                </data>
            )}

            {(!!requestAlreadySent && !isProcessing) && (
                <data>
                    <FormText>
                        {getMessage('components.login.forgot_password.already_sent_1')}
                    </FormText>
                    <FormText>
                        {getMessage('components.login.forgot_password.already_sent_2')}
                    </FormText>
                </data>
            )}
        </div>
    );
}

ForgottenPasswordRequestComponent.propTypes = {
    isButtonDisabled: PropTypes.bool.isRequired,
    getMessage: PropTypes.func.isRequired,
    userConfig: PropTypes.shape({
        value: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
    }).isRequired,
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    isProcessing: PropTypes.bool.isRequired,
    requestAlreadySent: PropTypes.bool.isRequired,
};

const ForgottenPasswordRequest = withMessages(stateLogic(ForgottenPasswordRequestComponent));

export default ForgottenPasswordRequest;
